export const frMagicLink = {
    // MAGIC LINK
    'magic.link.pageTitle': 'Connexion IrriTalk',
    'magic.link.title': 'Connexion IrriTalk',
    'magic.link.message.loading': 'Chargement...',
    'magic.link.message.click.to.open': "Cliquez pour ouvrir l'application",
    'magic.link.message.no.app':
        "Si l'application IrriTalk n'est pas installée sur cet appareil, alors vous pouvez l'obtenir en suivant ce lien : {link} puis en relançant le lien de connexion depuis votre mail d'invitation.",
    'magic.link.message.success':
        "Votre lien de connexion a bien été transmis à l'application IrriTalk. Vous pouvez maintenant fermer cette page.",
};
